import { ArrowRightIcon, ExternalLinkIcon } from "@radix-ui/react-icons"
import Link from "next/link"
import styles from "./LinkButton.module.scss"
import cn from "classnames"

const LinkButton = ({
  data,
  onClick = () => {},
  className = "",
  iconClassName = "",
  icon,
  ...rootProps
}) => {
  let {
    link_url: url,
    link_text: text,
    link_blank: shouldOpenInNewTab,
    link_anchor: anchor,
    show_arrow: showArrow,
  } = data
  const blank = shouldOpenInNewTab ? "_blank" : "_self"

  const innerButton = (
    <>
      <span>{text}</span>
      {icon ? (
        icon
      ) : (
        <>
          {shouldOpenInNewTab && (
            <ExternalLinkIcon
              className={cn(styles.buttonIcon, iconClassName)}
            />
          )}
          {!shouldOpenInNewTab && showArrow && (
            <ArrowRightIcon className={cn(styles.buttonIcon, iconClassName)} />
          )}
        </>
      )}
    </>
  )

  const urlWithAnchor = anchor ? `${url || ""}#${anchor}` : url
  if (urlWithAnchor) {
    return (
      <Link href={urlWithAnchor}>
        <a
          className={`button ${className}`}
          target={blank}
          onClick={onClick}
          {...rootProps}
        >
          {innerButton}
        </a>
      </Link>
    )
  } else if (icon || text) {
    return <button className={`button ${className}`}>{innerButton}</button>
  }

  return null
}

export default LinkButton
